export const CoreUiRoutePath = {
  Prefix: "coreui",
  Home: "*",
  Dashboard: "dashboard",
  NotFoundError: "404",
  InternalServerError: "500",
};
